import * as React from "react";
import { Box, Button } from "@mui/material";
import PillSearchField from "../PillSearchField";
import ReportDateRangePicker from "./ReportDateRangePicker";
import { useTranslation } from "../../i18n/LanguageContext";

// Filter row shared by the patient/therapist reports pages — one free-text
// search box (matches order number, test identifier, OR substrate on the
// backend) plus a date-range control on the right.
function ReportsFilterBar({
  search,
  onSearchChange,
  resultCount,
  loading,
  startDate,
  endDate,
  onDateRangeChange,
  disabled,
}) {
  const { t } = useTranslation();
  const hasActiveFilter = Boolean(search || startDate || endDate);

  const clearAll = () => {
    onSearchChange("");
    onDateRangeChange("", "");
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center", mb: "20px" }}>
      <Box sx={{ flex: "1 1 260px", minWidth: 220 }}>
        <PillSearchField
          value={search}
          onChange={onSearchChange}
          placeholder={t("portal.reports.filters.searchPlaceholder")}
          resultCount={resultCount}
          loading={loading}
        />
      </Box>
      <ReportDateRangePicker
        startDate={startDate}
        endDate={endDate}
        onChange={onDateRangeChange}
        disabled={disabled}
      />
      {hasActiveFilter && (
        <Button size="small" onClick={clearAll} disabled={disabled} sx={{ textTransform: "none" }}>
          {t("portal.reports.filters.clear")}
        </Button>
      )}
    </Box>
  );
}

export default ReportsFilterBar;
